module.exports = __webpack_public_path__ + "static/media/search.0cf0cd38.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/search.png
// module id = 343
// module chunks = 0